import { AxiosResponse } from 'axios';

import { IExerciseProof, IExerciseProofRequest } from './exercise-proof.interface';

import { axiosApiInstance } from 'services/config';
import {
  IAttachmentDownloadResponse,
  IAttachmentUploadUrlResponse,
} from 'utils/attachments';

class ExerciseProofApi {
  async getByAccount(accountId: number): Promise<IExerciseProof[]> {
    const response: AxiosResponse<IExerciseProof[]> = await axiosApiInstance.get(
      `exercise-proof/account/${accountId}`,
    );
    return response.data;
  }

  async createAttachmentUploadUrl(
    fileName: string,
    contentType: string,
  ): Promise<IAttachmentUploadUrlResponse> {
    const response: AxiosResponse<IAttachmentUploadUrlResponse> =
      await axiosApiInstance.post('exercise-proof/attachment/upload-url', {
        fileName,
        contentType,
      });
    return response.data;
  }

  async getAttachmentDownloadUrl(proofId: number): Promise<IAttachmentDownloadResponse> {
    const response: AxiosResponse<IAttachmentDownloadResponse> =
      await axiosApiInstance.get(`exercise-proof/${proofId}/download-url`);
    return response.data;
  }

  // Mirrors KnowledgeAreaLevelExercisesApi.deletePendingAttachment — best-effort
  // cleanup for a quarantined upload that was never linked to a proof.
  async deletePendingAttachment(storageKey: string): Promise<void> {
    await axiosApiInstance.delete('exercise-proof/attachment/pending', {
      params: { storageKey },
    });
  }

  async create(requestData: IExerciseProofRequest): Promise<IExerciseProof> {
    const response: AxiosResponse<IExerciseProof> = await axiosApiInstance.post(
      'exercise-proof',
      requestData,
    );
    return response.data;
  }

  async update(id: number, requestData: IExerciseProofRequest): Promise<IExerciseProof> {
    const response: AxiosResponse<IExerciseProof> = await axiosApiInstance.put(
      `exercise-proof/${id}`,
      requestData,
    );
    return response.data;
  }

  async remove(id: number): Promise<void> {
    await axiosApiInstance.delete(`exercise-proof/${id}`);
  }
}

export { ExerciseProofApi };
